import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  @Input() endDate!: string; // ISO date string
  @Input() showDays: boolean = true;
  @Input() showLabel: boolean = true;
  @Input() label: string = 'Time Left:';
  
  timeLeft: any = {
    total: 0,
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00'
  };
  
  private timerSubscription?: Subscription;
  
  constructor(private router: Router) {}
  
  ngOnInit(): void {
    // Set default end date if none provided (7 days from now for testing)
    if (!this.endDate) {
      const futureDate = new Date();
      futureDate.setDate(futureDate.getDate() + 7);
      this.endDate = futureDate.toISOString();
    }
    this.startCountdown();
  }
  
  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
  
  private startCountdown(): void {
    if (!this.endDate) return;
    
    // Update immediately
    this.updateTimeLeft();
    
    // Then update every second
    this.timerSubscription = interval(1000)
      .pipe(
        takeWhile(() => this.timeLeft.total > 0)
      )
      .subscribe(() => {
        this.updateTimeLeft();
      });
  }
  
  private updateTimeLeft(): void {
    if (!this.endDate) {
      this.timeLeft = {
        total: 0,
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      };
      return;
    }

    const now = new Date().getTime();
    const endTime = new Date(this.endDate).getTime();
  
    
    const total = endTime - now;
    
    if (total <= 0) {
      this.timeLeft = {
        total: 0,
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      };
      return;
    }
    
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    const hours = Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((total % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((total % (1000 * 60)) / 1000);
    
    this.timeLeft = {
      total,
      days: days.toString().padStart(2, '0'),
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0')
    };
  }
  
  navigateToBpmArena(): void {
    this.router.navigate(['/bpmarena']);
  }
}